// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"3bc232c8","421":"83571726","467":"15c297f4","484":"400d8e1d","869":"54e2cf74"}[chunkId] + ".chunk.css";
};